// extracted by mini-css-extract-plugin
export default {"workspace":"Workspace_workspace__jimkm","scrollable":"Workspace_scrollable__4pjsY","content":"Workspace_content__Mtrsx"};